export const COLOR_LEVELS = {
    BAD_5: 'bad 5',
    BAD_4: 'bad 4',
    BAD_3: 'bad 3',
    BAD_2: 'bad 2',
    BAD_1: 'bad 1',
    NORMAL: 'normal',
    GOOD_1: 'good 1',
    GOOD_2: 'good 2',
    GOOD_3: 'good 3',
    GOOD_4: 'good 4',
    GOOD_5: 'good 5',
}

export const getColor = (level) => {
    switch(level){
        case COLOR_LEVELS.BAD_5:
            return '#FF0000'; //Pure red

        case COLOR_LEVELS.BAD_4:
            return '#FF3D00'; //Orange-red (Material Deep Orange A700) 

        case COLOR_LEVELS.BAD_3:
            return '#FF6F00'; //Pure orange (Material Orange A700)

        case COLOR_LEVELS.BAD_2:
            return '#FF9800'; //Orange-leaning (Material Orange 500)

        case COLOR_LEVELS.BAD_1:
            return '#FFB74D'; //Light orange (between pure orange and yellow)

        case COLOR_LEVELS.NORMAL:
            return 'grey';

        case COLOR_LEVELS.GOOD_1:
            return '#A5D6A7'; // Level 1 - Very light green

        case COLOR_LEVELS.GOOD_2: // Level 2 - Light green
            return '#66BB6A';

        case COLOR_LEVELS.GOOD_3: // Level 3 - Pure green
            return '#4CAF50';

        case COLOR_LEVELS.GOOD_4: // Level 4 - Strong green
            return '#388E3C';

        case COLOR_LEVELS.GOOD_5: // Level 5 - Very strong/dark green
            return '#1B5E20';
    }
}